// src/data/zencode/zenordner.js
const ZenOrdner = {
  slug: "zenordner",
  title: "ZenOrdner",
  description: "Eine minimalistische App zur digitalen Ordnung.",
  tags: ["Ordnung", "Struktur", "Desktop"],
  icon: "folder",
  cover: "/images/projects/zenordner.png",
  content: `
### Was ist ZenOrdner?

ZenOrdner hilft, deinen digitalen Schreibtisch klar und fokussiert zu halten – durch einfaches, bewusstes Ordnen.

### Warum es entstanden ist

Digitale Unordnung führt oft zu innerem Stress. ZenOrdner schafft Raum.

👉 [Mehr erfahren](/zencode/zenordner)
  `,
};

export default ZenOrdner;
